// removed by extract-text-webpack-plugin
module.exports = {"action-container":"_1odAi","breakline":"_3BE6b","timer":"_3g3ZM"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Prompt/PageClosedTargetNotReached/PageClosedTargetNotReached.scss
// module id = ./src/components/Prompt/PageClosedTargetNotReached/PageClosedTargetNotReached.scss
// module chunks = 4